import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { postAPI } from '../../api';
import { useAuth } from '../../contexts/AuthContext';
import { useSite } from '../../contexts/SiteContext';
import CertifiedSiteList from '../../components/CertifiedSiteList';
import { mockCertifiedSites } from '../../data/certifiedSites';
import { CertifiedSite } from '../../types';

const HomeContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 0.5rem 0; */
`;

const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

// 메인 배너
const MainBanner = styled.div`
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  
  img {
    width: 100%;
    height: 320px;
    object-fit: cover;

    @media (max-width: 768px) {
      height: 200px;
    }
  }
`;

// 기능 버튼
const FunctionButtons = styled.div`
  display: flex;
  gap: 1rem;
  
  @media (max-width: 768px) {
    /* flex-direction: column; */
  }
`;

const FunctionButton = styled(Link)`
  flex: 1;
  background-color: white;
  border: 1px solid #eaeaea;
  border-radius: 0.5rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.2s;
  
  &:hover {
    border-color: #ef4444;
    transform: translateY(-3px);
  }

  @media (max-width: 768px) {
    padding:0.3rem;
    gap: 0.2rem;
  }
`;

const ButtonIcon = styled.div`
  font-size: 1.5rem;
  color: #ef4444;
  margin-bottom: 0.25rem;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const ButtonLabel = styled.span`
  font-weight: 500;
  color: #111827;
`;

// CertifiedSection 관련 스타일 컴포넌트들은 CertifiedSiteList 컴포넌트로 이동

const Home: React.FC = () => {
  const [certifiedSites, setCertifiedSites] = useState<CertifiedSite[]>([]);
  const { siteConfig } = useSite();

  useEffect(() => {
    // 실제 API 연동 시 여기에서 데이터를 가져오고, 
    // 지금은 목업 데이터의 일부만 표시 (6개)
    setCertifiedSites(mockCertifiedSites);
  }, []);

  return (
    <HomeContainer>
      <RightContent>
        {/* 메인 배너 */}
        <MainBanner>
          <img src={
            siteConfig.siteName === '먹튀위키' ? '/images/mt_banner.png' : '/images/tt_banner.png'
          } alt="메인 배너" />
        </MainBanner>

        {/* 기능 버튼 */}
        <FunctionButtons>
          <FunctionButton to="/boards/3">
            <ButtonIcon>🚨</ButtonIcon>
            <ButtonLabel>먹튀신고</ButtonLabel>
          </FunctionButton>
          <FunctionButton to="/exchange">
            <ButtonIcon>💰</ButtonIcon>
            <ButtonLabel>꽁머니 교환</ButtonLabel>
          </FunctionButton>
          <FunctionButton to="/attendance">
            <ButtonIcon>✅</ButtonIcon>
            <ButtonLabel>출석체크</ButtonLabel>
          </FunctionButton>
        </FunctionButtons>

        {/* 공식 보증업체 섹션 */}
        <CertifiedSiteList sites={certifiedSites} />
      </RightContent>
    </HomeContainer>
  );
};

export default Home;